<template>
  <div>
    <base-form
      v-model="productRequestData"
      @form:submit-success="handleRequestSuccess"
      method="post"
      action="justopp/product-request"
      :config="formConfig"
    ></base-form>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import useCarts from "@/client/extensions/composition/useCarts";

export default {
  props: {},
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    let carts = useCarts(props);
    return { asyncOps, asyncOpsReady, asyncStatus, carts };
  },
  data: function() {
    return {
      formConfig: {
        fields: {
          fullName: {
            name: "fullName",
            label: "justopp.productRequest.form.fields.fullName",
            type: "text",
            icon: "user",
            validation: {
              required: {},
            }
          },
          email: {
            name: "email",
            label: "justopp.productRequest.form.fields.email",
            type: "email",
            icon: "mail",
            validation: {
              required: {},
              email: {},
            }
          },
          content: {
            name: "content",
            label: "justopp.productRequest.form.fields.content",
            type: "textArea",
            icon: "question",
            required: {
              required: {},
              maxLength: {
                params: {
                  max: 200,
                }
              }
            },
            maxCharacters: 200,
          },
        }
      },
      productRequestData: {

      }
    };
  },
  emits: ['product-requester:success'],
  methods: {
    reset(){
      this.productRequestData = {};
    },
    handleRequestSuccess(e) {
      this.$emit('product-requester:success', {...this.productRequestData})
      this.$s.ui.notification('justopp.productRequest.successNotification','success');
      this.reset();
    },
  }

};
</script>

<style scoped lang="scss">

</style>
